var exports = {
  "kL": "ChannelDivider.module__container___LS1KOH",
  "JW": "ChannelDivider.module__unreadContainer___LS1KOH",
  "iN": "ChannelDivider.module__unreadDate___LS1KOH",
  "n8": "ChannelDivider.module__line___LS1KOH",
  "Qq": "ChannelDivider.module__text___LS1KOH",
  "KQ": "ChannelDivider.module__unreadLine___LS1KOH",
  "vD": "ChannelDivider.module__dateWithUnreadText___LS1KOH",
  "HN": "ChannelDivider.module__unreadBadge___LS1KOH",
};

module.exports = exports;
